// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Header cell padding */
.py-table .ag-header-cell {
	padding-left: 4px !important;
	padding-right: 4px !important;
}

/* First/last column padding overrides */
.py-table .ag-column-first {
	padding-left: 15px !important;
}

.py-table .ag-header-cell.ag-column-first {
	padding-left: 15px !important;
}

.py-table .ag-column-last {
	padding-right: 15px !important;
}

.py-table .ag-cell.py-table-dropdown-cell {
	padding-left: 4px !important;
	padding-right: 4px !important;
}

/* Popup and overlay customizations */
.py-table .ag-popup {
	position: static !important;
}

.py-table .ag-overlay-loading-wrapper {
	background-color: transparent !important;
	pointer-events: none !important;
}

.py-table .ag-header-container,
.py-table .ag-center-cols-container {
	min-width: 100%;
}

/* Override Alpine theme's 150px min-height that causes extra space with few rows in autoHeight mode.
   autoHeight is only enabled when there are rows, so this won't affect the empty state. */
.py-table .ag-layout-auto-height .ag-center-cols-viewport,
.py-table .ag-layout-auto-height .ag-center-cols-container {
	min-height: unset !important;
}

/* In autoHeight mode the grid hugs its content, so the last row's bottom border
   stacks directly on top of the grid wrapper's bottom border and reads as a
   doubled/extra border. Drop the redundant last-row border so a single border
   closes the table, matching fixed-height/scrollable tables. */
.py-table .ag-layout-auto-height .ag-row-last {
	border-bottom: none !important;
}
`, "",{"version":3,"sources":["webpack://./../../packages/py-components/src/components/organisms/Table/Table.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;CACC,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA,wCAAwC;AACxC;CACC,6BAA6B;AAC9B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA,qCAAqC;AACrC;CACC,2BAA2B;AAC5B;;AAEA;CACC,wCAAwC;CACxC,+BAA+B;AAChC;;AAEA;;CAEC,eAAe;AAChB;;AAEA;0FAC0F;AAC1F;;CAEC,4BAA4B;AAC7B;;AAEA;;;+DAG+D;AAC/D;CACC,8BAA8B;AAC/B","sourcesContent":["/* Header cell padding */\n.py-table .ag-header-cell {\n\tpadding-left: 4px !important;\n\tpadding-right: 4px !important;\n}\n\n/* First/last column padding overrides */\n.py-table .ag-column-first {\n\tpadding-left: 15px !important;\n}\n\n.py-table .ag-header-cell.ag-column-first {\n\tpadding-left: 15px !important;\n}\n\n.py-table .ag-column-last {\n\tpadding-right: 15px !important;\n}\n\n.py-table .ag-cell.py-table-dropdown-cell {\n\tpadding-left: 4px !important;\n\tpadding-right: 4px !important;\n}\n\n/* Popup and overlay customizations */\n.py-table .ag-popup {\n\tposition: static !important;\n}\n\n.py-table .ag-overlay-loading-wrapper {\n\tbackground-color: transparent !important;\n\tpointer-events: none !important;\n}\n\n.py-table .ag-header-container,\n.py-table .ag-center-cols-container {\n\tmin-width: 100%;\n}\n\n/* Override Alpine theme's 150px min-height that causes extra space with few rows in autoHeight mode.\n   autoHeight is only enabled when there are rows, so this won't affect the empty state. */\n.py-table .ag-layout-auto-height .ag-center-cols-viewport,\n.py-table .ag-layout-auto-height .ag-center-cols-container {\n\tmin-height: unset !important;\n}\n\n/* In autoHeight mode the grid hugs its content, so the last row's bottom border\n   stacks directly on top of the grid wrapper's bottom border and reads as a\n   doubled/extra border. Drop the redundant last-row border so a single border\n   closes the table, matching fixed-height/scrollable tables. */\n.py-table .ag-layout-auto-height .ag-row-last {\n\tborder-bottom: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
